import styled from 'styled-components';

export const StyledArticles = styled.section`
  display: flex;
  min-height: calc(100vh - 6vh - 8vh);
  flex-direction: column;
  gap: var(--space-6);
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--space-6) var(--space-4) var(--space-9);

  @media (min-width: 786px) {
    padding: var(--space-7) var(--space-6) var(--space-9);
  }

  @media (min-width: 1200px) {
    display: grid;
    grid-template-columns: 260px 1fr;
    align-items: start;
    gap: var(--space-7);
  }
`;
